import { Request } from '../../../httpClient/serverApi/requests/Request';
import WebHttpClient from '../../../httpClient/WebHttpClient';
import { IListWithTokenFetcher } from '../../../ts/fetchers/IListWithTokenFetcher';
import { ListResultWithToken } from '../../../ts/fetchers/ListResultWithToken';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IPagedItemsWithTokenParams } from '../../../ts/ServerApi/types/IPageWithToken';

export class WebClientListWithTokenResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListWithTokenFetcher<TResource> {

  constructor(
    private requestType: new (params: IPagedItemsWithTokenParams) => Request<IPagedItemsWithTokenParams, TRequestResult>,
    private resultMapper: (result: TRequestResult) => TResource[]
  ) { }

  public fetchList(params: IPagedItemsWithTokenParams): Promise<ListResultWithToken<TResource>> {
    return WebHttpClient.sendRequest(new this.requestType(params))
      .then((result: TRequestResult) => {
        const nextPageToken = result.nextPageToken;
        return new ListResultWithToken<TResource>(this.resultMapper(result), nextPageToken);
      });
  }

}